var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.skuName"),
                          prop: "skuName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessPurchaseOrder2.form.skuName"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuName", $$v)
                            },
                            expression: "queryParams.skuName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsPage.skuCode"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: "SKU",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.setFlag != "draft"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("table.statusText") } },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list":
                                  _vm.GOODS_SKU_STATUS_NORMAL_STRING,
                                placeholder: _vm.$t("table.statusText"),
                                "collapse-tags":
                                  _vm.tempStatus && _vm.tempStatus.length > 2,
                                multiple: "",
                              },
                              model: {
                                value: _vm.tempStatus,
                                callback: function ($$v) {
                                  _vm.tempStatus = $$v
                                },
                                expression: "tempStatus",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
                  ? _c(
                      "el-col",
                      {
                        attrs: { span: _vm.colSpan, prop: "dimensionsChecked" },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("goodsPage.Dimensional") } },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.STATUS_YES_TRUE,
                                placeholder: _vm.$t("goodsPage.Dimensional"),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParams.dimensionsChecked,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryParams,
                                    "dimensionsChecked",
                                    $$v
                                  )
                                },
                                expression: "queryParams.dimensionsChecked",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan, prop: "isHide" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessPurchaseForecast.skuStatus"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.HIDE_STATUS_ENABLED_NUM,
                                placeholder: _vm.$t(
                                  "BusinessPurchaseForecast.skuStatus"
                                ),
                              },
                              on: { change: _vm.handleQuery },
                              model: {
                                value: _vm.queryParams.isHide,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "isHide", $$v)
                                },
                                expression: "queryParams.isHide",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("customerNameText"),
                              prop: "loginName",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("goodsSku.detail.Barcode"),
                          prop: "barCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("goodsSku.detail.Barcode"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.barCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "barCode", $$v)
                            },
                            expression: "queryParams.barCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
                  ? _c(
                      "el-col",
                      [
                        _vm.$store.getters.cusId
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreate("left")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ExcelConfig.Title")))]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onExportORDINARY },
                          },
                          [_vm._v(_vm._s(_vm.$t("exportText")))]
                        ),
                        _vm.queryParams.setFlag ==
                          _vm.GOODS_COMBO_TYPES.ORDINARY &&
                        _vm.$store.getters.cusId
                          ? _c(
                              "el-button",
                              {
                                staticClass: "main-btn",
                                attrs: { type: "primary" },
                                on: { click: _vm.onAdd },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("goodsSku.page.commonSKU"))
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onDownload },
                          },
                          [_vm._v(_vm._s(_vm.$t("downloadText")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.visibleTooltip = true
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("goodsPage.rule")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.deleteSelect },
                          },
                          [_vm._v(_vm._s(_vm.$t("bulkDelText")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.bulkDisable },
                          },
                          [_vm._v(_vm._s(_vm.$t("bulkInactiveText")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onExportHistory("SGOO.SKU_IMPORT")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("importHistoryText")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.setFlag == _vm.GOODS_COMBO_TYPES.PACKAGE
                  ? _c(
                      "el-col",
                      [
                        _vm.$store.getters.cusId
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onCreate("right")
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ExcelConfig.Title")))]
                            )
                          : _vm._e(),
                        _vm.queryParams.setFlag ==
                          _vm.GOODS_COMBO_TYPES.PACKAGE &&
                        _vm.$store.getters.cusId
                          ? _c(
                              "el-button",
                              {
                                staticClass: "main-btn",
                                attrs: { type: "primary" },
                                on: { click: _vm.onAdd },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("goodsSku.page.packageSKU"))
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onExportHistory(
                                  "SGOO.PACKAGE_SKU_IMPORT_CSG"
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("importHistoryText")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    (col.prop !== "bjTableAction" && col.prop !== "status") ||
                    (col.prop === "status" && _vm.setFlag !== "draft")
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "materialMainImages"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-spacebetween",
                                          },
                                          [
                                            _c("BjViewUrl", {
                                              attrs: {
                                                url: (scope.row[col.prop] ||
                                                  [])[0],
                                                height: "80px",
                                                preview: "",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : col.prop === "skuName"
                                      ? [
                                          _vm.setFlag ==
                                          _vm.GOODS_COMBO_TYPES.ORDINARY
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(scope.row[col.prop])
                                                ),
                                              ])
                                            : _c(
                                                "span",
                                                [
                                                  _vm.setFlag == "draft" &&
                                                  scope.row.setFlag == 1
                                                    ? _c("el-tag", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "goodsSku.page.Set"
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[col.prop]
                                                      )
                                                  ),
                                                ],
                                                1
                                              ),
                                        ]
                                      : col.prop === "barCode"
                                      ? [
                                          _vm.setFlag ==
                                          _vm.GOODS_COMBO_TYPES.ORDINARY
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[col.prop])
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      : col.prop === "volume"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                (
                                                  (scope.row["length"] *
                                                    scope.row["width"] *
                                                    scope.row["height"]) /
                                                  1000000
                                                ).toFixed(6)
                                              ) +
                                              "m³ "
                                          ),
                                        ]
                                      : col.prop === "cartonCBM"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                (
                                                  (scope.row["cartonLength"] *
                                                    scope.row["cartonWidth"] *
                                                    scope.row["cartonHeight"]) /
                                                  1000000
                                                ).toFixed(6)
                                              ) +
                                              "m³ "
                                          ),
                                        ]
                                      : col.prop === "status"
                                      ? _c("el-tag", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.GOODS_SKU_STATUS.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ])
                                      : col.prop === "needExpired"
                                      ? _c("el-tag", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.STATUS_YES_NUM.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ])
                                      : col.prop === "dimensionsChecked"
                                      ? _c("el-tag", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.STATUS_YES_TRUE.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ])
                                      : col.prop === "isHide"
                                      ? _c("el-tag", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.HIDE_STATUS_ENABLED_NUM.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                            )
                                          ),
                                        ])
                                      : col.prop
                                          .toLocaleLowerCase()
                                          .includes("price")
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$number2money(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _vm.setFlag ==
                                    _vm.GOODS_COMBO_TYPES.ORDINARY
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:CSGGoodsSkuOrdinaryView",
                                                    arg: "CSGGoodsSkuOrdinaryView",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onView(props.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("viewText"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:CSGGoodsSkuOrdinaryEdit",
                                                    arg: "CSGGoodsSkuOrdinaryEdit",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEdit(props.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("editText"))
                                                ),
                                              ]
                                            ),
                                            props.row.isHide
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onEnable(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("enableText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !props.row.isHide
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: { type: "text" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onDisable(
                                                          props.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("disableText")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "delete-btn",
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDel(props.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("delText"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.setFlag == _vm.GOODS_COMBO_TYPES.PACKAGE
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:CSGGoodsSkuPackageView",
                                                    arg: "CSGGoodsSkuPackageView",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onView(props.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("viewText"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "permission",
                                                    rawName:
                                                      "v-permission:CSGGoodsSkuPackageEdit",
                                                    arg: "CSGGoodsSkuPackageEdit",
                                                  },
                                                ],
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEdit(props.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("editText"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                staticClass: "delete-btn",
                                                attrs: { type: "text" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onDel(props.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("delText"))
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ExcelImportDialog", {
        ref: "ExcelImport",
        on: { submit: _vm.onSubmit },
      }),
      _c(
        "BjDialog",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visibleTooltip,
              expression: "visibleTooltip",
            },
          ],
          attrs: { visible: _vm.visibleTooltip },
          on: {
            close: function ($event) {
              _vm.visibleTooltip = false
            },
          },
        },
        [_c("skuRule")],
        1
      ),
      _c("ExportHistory", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        ref: "ExportHistoryRefs",
        attrs: {
          title: _vm.$t("importHistoryText"),
          width: "850px",
          visible: _vm.visible,
        },
        on: {
          close: function ($event) {
            _vm.visible = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }